import {lazy} from 'react';

export const ApiLinkLazy = lazy(() => import(/* webpackChunkName: "apiLink" */ '.'));
